import { useCallback, useContext } from 'react';
import useWebSocket from 'react-use-websocket';
import { MeContext } from '../../../contexts/me.context';
import { fetchAuthSession } from '@aws-amplify/auth';
import { convertToMS } from '@chiroup/core';

const useWS = (
  sessionId: string,
  subscription: string,
  onMessage: (data: any) => void,
) => {
  const { me } = useContext(MeContext);

  const getSocketUrl = useCallback(async () => {
    const { idToken } = (await fetchAuthSession()).tokens ?? {};
    return `${import.meta.env.VITE_WEBSOCKET_URL}?token=${idToken}&clinicId=${me
      .selectedClinic?.ID}&locationId=${
      me.selectedLocation
    }&sessionId=${sessionId}&subscription=${subscription}`;
  }, [me.selectedClinic?.ID, me.selectedLocation, sessionId, subscription]);

  const { readyState } = useWebSocket<any | null>(getSocketUrl, {
    share: true,
    shouldReconnect: () => true,
    retryOnError: true,
    reconnectAttempts: 100,
    reconnectInterval: (attemptNumber) =>
      Math.min(convertToMS(Math.pow(2, attemptNumber)), 60000),
    onMessage: (message) => {
      onMessage(JSON.parse(message.data));
    },
    onError: (event) => {
      console.error('WebSocket error:', event);
    },
    onClose: (event) => {
      console.error('WebSocket closed:', event);
    },
  });

  return {
    readyState,
  };
};

export default useWS;
